import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { store } from 'react-notifications-component';

import { commonApiTypes } from 'types/common';
import { loginReducerTypes } from 'types/store/auth/login';
import { COOKIES_NAME } from 'utils/constants/common';
import { APP_NAME, DANGER } from 'utils/constants/notifyTypes';
import { setCookie } from 'utils/helpers/cookieFunc';
import { getToaster } from 'utils/helpers/toast';

import { loginState } from './loginState';

const loginSlice = createSlice({
    name: 'login',
    initialState: loginState,
    reducers: {
        loginStart: (state, action: PayloadAction<loginReducerTypes.ILoginForm>) => {
            return {
                ...state,
                ...action.payload,
                isLoading: true,
            };
        },
        loginSuccess: (state, action: PayloadAction<loginReducerTypes.ILoginResponse>) => {
            setCookie(COOKIES_NAME.TOKEN, action.payload.data.token, false);
            setCookie(COOKIES_NAME.IS_LOG_IN, 'true', true);
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isLoginSuccess: true,
                password: '',
                email: '',
            };
        },
        loginFailed: (state, action: PayloadAction<commonApiTypes.IApiFailed>) => {
            store.addNotification(getToaster(`${APP_NAME} Login`, action.payload.error, DANGER));
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isLoginSuccess: false,
                password: '',
                email: '',
            };
        },
        loginReset: () => {
            return {
                ...loginState,
            };
        },
    },
});

export { loginSlice };
